import { SVGProps, Ref, forwardRef } from 'react';

export const ImageStackFilledSizeSize4Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path
                d="M12 1c5.042 0 7.605.346 8.555 2.167-.761-.295-1.592-.492-2.466-.63-1.679-.264-3.713-.337-6.09-.337-2.375 0-4.41.073-6.088.337-.874.138-1.705.335-2.467.63C4.394 1.346 6.958 1 12 1"
                fill="currentColor"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M1.207 13.5C.226 5.188 2.557 4 12 4c9.444 0 11.774 1.188 10.793 9.5-.196 1.66-.406 3.036-.685 4.174l-4.985-3.609-3.418 2.355-5.117-3.52-6.693 4.784c-.28-1.141-.492-2.52-.688-4.184M15.75 9C14.438 9 14 9.875 14 10.75s.438 1.75 1.75 1.75 1.75-.875 1.75-1.75S17.063 9 15.75 9"
                fill="currentColor"
            />
            <path
                d="m17.097 16.269 4.425 3.204C20.227 22.45 17.762 23 12 23c-5.76 0-8.224-.55-9.52-3.522L8.608 15.1l5.098 3.507z"
                fill="currentColor"
            />
        </g>
    </svg>
));
ImageStackFilledSizeSize4Glyph.displayName = 'ImageStackFilledSizeSize4Glyph';
